var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rule-group-statement',{attrs:{"value":_vm.statement && _vm.statement.rule_group_id,"ruleGroupId":_vm.statement && _vm.statement.rule_group_id,"isEdit":_vm.isEdit}}),_c('negation',{attrs:{"value":!_vm.statement.negation,"isEdit":_vm.isEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }